import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
/* Helpers */
import { getPartnerEndpoints } from '../../../helpers/settings/partnerEndpoints';
import { handleAPIRequest } from '../../../helpers/handleAPIRequest';
import { getCookie, isIE } from '../../../helpers/utils';
import { deleteItemFromLS } from '../../../helpers/localStorage';
/* Redux */
import { useDispatch, useSelector } from 'react-redux';
import { setPassedThunk } from '../../../redux/actions';
export const BizmaticaHiddenForm = ({ returnUrl, useSubmit = true, children }) => {
  const { token } = useSelector(state => state);
  const { token: userToken } = useSelector(state => state?.user);
  const { fromSimulation } = useSelector(state => state?.passed );
  const { amount, payment, purpose, numberOfInstallments } = useSelector(state => state.currentSimulation);
  const { current: currentAmount } = amount;
  const { current: currentPayment } = payment;
  const { text: purposeText, code: purposeCode } = purpose;
  const { min: minNumberOfInstallments, max: maxNumberOfInstallments } = numberOfInstallments;
  
  const dispatch = useDispatch();
  const setPassed = (payload) => dispatch(setPassedThunk(payload));

  const history = useHistory();
  const location = useLocation();
  const { search = '' } = location;

  const isFixedRateMod = () => {
    // da modificare quando introdurrò il tool per passare da "rata fissa" a "durata fissa"
    return true;
  }

  const setActionUrl = () => {
    switch (sessionStorage.getItem("bizmaticaEndpointEnvironment")?.toUpperCase()) {
      case "SVIBIZ":
        return "http://10.1.42.41:8080/ds-webapp/start";
      case "SVIMIS":
        return "https://richiesta-svi.int.compassonline.it/ds-webapp/start";
      case "COLMIS":
        return "https://richiesta-col.int.compassonline.it/ds-webapp/start";
      case "PRODMIS":
        return "https://richiesta.int.compassonline.it/ds-webapp/start";
      default:
        return getPartnerEndpoints("compass").redirect.formAction;
    }
  }

  const submitForm = function(formSelector) {
    deleteItemFromLS('homePage');
    
    if (isIE()) {
      window.location.href = '/offline/ds/dsoffline.html';
    } else {
      const form = window.$(`.${formSelector}`);
      //add unbind to permit form submit
      form.unbind('submit');
      const data = form.serialize();

      //console.log(data);
      
      const callbacks = {
        200: function(response) {
          if (response.data === "OK" || sessionStorage.getItem("simulatorIsDown") === "false") {
              form.submit();
          } else {
            window.location.href = window.location.origin + "/fissa-appuntamento/?prodotto=1&utm_source=DS&utm_campaign=downDs&mediacode=4492";
          }
        },
        400: function() {
          form.submit();
        },
        500: function() {
          form.submit();
        },
        default: function() {
          form.submit();
        },
      };
      
      handleAPIRequest({
        method: "POST",
        url: getPartnerEndpoints("compass").api.checkIfSimulatorIsDown,
        data,
      }, callbacks);
    }
  }

  const handleSubmit = (e, submitFormProp = true) => {
    if(
      useSubmit 
      || token
    ) {
      submitForm("bizmatica-form");
    } else {
      setPassed({ fromSimulation: true });
      history.push(`/dati-utente.html${search}`);
    }
  }

  const getToken = () => {
    if(fromSimulation && userToken && userToken !== '') return userToken;
    if(token && token !== '') return token?.toString();

    return '';
  }

  //
  const childrenWithProps = React.Children.map(children, child => React.cloneElement(child, { submitEvent: handleSubmit }));

  return (
    <form className="bizmatica-form" action={setActionUrl()} method="post">
      <input type="hidden" name="SC_TOKEN" value={getToken()}></input>
      {
        /**
          TOKEN with cel and cf
          <input type="hidden" name="SC_USER_TOKEN" value={userToken}></input>
         */
      }
      <input type="hidden" name="SC_TIPO_OFFERTA" value={isFixedRateMod ? "1" : "2"}></input>
      <input type="hidden" name="SC_IMPORTO_RATA" value={isFixedRateMod ? currentPayment?.toString() : ""}></input>
      <input type="hidden" name="SC_NUMERO_RATE" value={isFixedRateMod ? maxNumberOfInstallments?.toString() : minNumberOfInstallments?.toString()}></input>
      <input type="hidden" name="SC_RICALCOLO" value={sessionStorage.getItem("skipRecap") === "true" ? "S" : "N"}></input>
      <input type="hidden" name="SC_IMPORTO_TOTALE" value={currentAmount?.toString()}></input>
      <input type="hidden" name="SC_BENE" value={purposeCode?.toString()}></input>
      <input type="hidden" name="SC_BENE_DESCR" value={purposeText?.toString()}></input>
      <input type="hidden" name="SC_BACKURL" value={returnUrl}></input>
      <input type="hidden" name="CODICE_APP" value="SIMCOMM"></input>
      <input type="hidden" name="CODICE_OFFERTA" value={isFixedRateMod ? "DGS_DF_WEB" : "DGS_RR_WEB"}></input>
      <input type="hidden" name="MOD_PAGAMENTO" value="RI"></input>
      <input type="hidden" name="URL_RITORNO" value=""></input>
      <input type="hidden" name="BROWSER_INFO" value={window.navigator.userAgent?.toString()}></input>
      <input type="hidden" name="UTM_SOURCE" value={getCookie("utm_source")}></input>
      <input type="hidden" name="UTM_MEDIUM" value={getCookie("utm_medium")}></input>
      <input type="hidden" name="UTM_CONTENT" value={getCookie("utm_content")}></input>
      <input type="hidden" name="MEDIACODE" value={getCookie("mediacode")}></input>
      <input type="hidden" name="UTM_TERM" value={getCookie("utm_term")}></input>
      <input type="hidden" name="UTM_CAMPAIGN" value={getCookie("utm_campaign")}></input>
      <input type="hidden" name="UTM_DATE" value={getCookie("utm_date")}></input>
      <input type="hidden" name="UTM_HISTORY" value={getCookie("utm_history")}></input>
      { childrenWithProps }
    </form>
  );
}